import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-comment",
  "use": "icon-right-comment-usage",
  "viewBox": "-4 -4 31 31",
  "content": "<symbol viewBox=\"-4 -4 31 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-comment\">\n<path d=\"M22.8333 3V19.2523L15.2697 19.2646L12.0009 22.5L8.72662 19.2646L1.16663 19.2523V3H22.8333ZM21.2861 4.62121H2.71386V17.6259L9.37857 17.6224L9.8362 18.1016L12.0027 20.174L14.6214 17.6224L21.2861 17.6259V4.62121ZM18.1952 11.134V12.7535H5.81195V11.134H18.1971H18.1952ZM18.1898 7.87762V9.49709H5.81195V7.87762H18.1916H18.1898Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol